<template>
  <div :class="`nav navCommon transparentNav ${$store.state.headerClassName || navHoverClass
    }`" @mouseover="toggleNavClass('whiteNav')" @mouseleave="toggleNavClass('')">
    <div class="nav-content">
      <!-- 企学院企业微信独立页面特殊处理 -->
      <a href="/" class="nav-logo_wrap"> </a>

      <div class="nav-func">
        <router-link to="/" class="nav-func_item">首页</router-link>
        <div id="product" class="nav-func_item nav-more">
          产品与服务
          <i class="arrow-down iconfont iconicon_nav_downArrow"></i>
          <div class="product-list">
            <div class="product-item">
              <div class="product-item__title">解决方案</div>
              <router-link to="/scene/teach" class="product-item__func">
                <div class="product-item__name">教育领域</div>
                <div class="product-item__tip">以AI大数据为核心，构建立体化产业教育生态圈与服务平台，为教育发展注入新动能</div>
              </router-link>
              <router-link to="/scene/science" class="product-item__func">
                <div class="product-item__name">民生领域</div>
                <div class="product-item__tip">借助AI大数据构建民生领域协同平台，提升业务效率，保障数据隐私性、安全性</div>
              </router-link>
              <router-link to="/scene/company" class="product-item__func">
                <div class="product-item__name">政务领域</div>
                <div class="product-item__tip">基于AI大数据，为政务提供多方协作、真实可信、数据资产化的基础设施</div>
              </router-link>
            </div>
            <div class="product-item">
              <div class="product-item__title"></div>
              <router-link to="/ability/business" class="product-item__func">
                <div class="product-item__name">司法领域</div>
                <div class="product-item__tip">基于AI大数据，为司法领域提供区块链可信基础设施与相应的解决方案</div>
              </router-link>
              <router-link to="/ability/user" class="product-item__func">
                <div class="product-item__name">其它领域</div>
                <div class="product-item__tip">基于AI大数据，提供区块链可信基础设施与相应的解决方案</div>
              </router-link>
            </div>
            <div class="product-item">
              <div class="product-item__title">增值服务</div>
              <router-link to="/ability/business" class="product-item__func">
                <div class="product-item__name">商业变现</div>
                <div class="product-item__tip">产品服务交付及变现</div>
              </router-link>
              <router-link to="/ability/brand" class="product-item__func">
                <div class="product-item__name">品牌营销</div>
                <div class="product-item__tip">全渠道引流获客转化</div>
              </router-link>
              <router-link to="/ability/user" class="product-item__func">
                <div class="product-item__name">用户运营</div>
                <div class="product-item__tip">分类运营触达沉淀用户</div>
              </router-link>
            </div>
            <div class="product-item">
              <div class="product-item__title">其它服务</div>
              <router-link to="/serviceWelfare" class="product-item__func">
                <div class="product-item__name">公益计划</div>
                <div class="product-item__tip">科技助力社会公益</div>
              </router-link>
            </div>
          </div>
        </div>
        <router-link id="serviceWelfare" to="/serviceWelfare" class="nav-func_item">公益计划</router-link>
        <router-link to="/introduce" class="nav-func_item">关于我们</router-link>
        <router-link to="/join" class="nav-func_item">加入我们</router-link>
        <!-- 暂时不需要
        <div id="aboutUs" class="nav-func_item nav-more">
          更多
          <i class="arrow-down iconfont iconicon_nav_downArrow"></i>
          <div class="more-list">
            <router-link to="/about" class="more-item">媒体报道</router-link>
            <router-link to="/news" class="more-item">更多资讯</router-link>
          </div>
        </div>
        -->
      </div>
      <div class="btns">
        <!-- 登录  免费试用 暂时不用先注释 -->
        <!-- <a href="https://admin.getchain.com.cn/login_page?reg_source=0101" target="_blank" class="login-btn navLogin" -->
        <!-- data-sensors="首页_首页_顶部导航-登录" data-count="pc-首页_顶部导航_登录" rel="nofollow">登录</a> -->
        <!-- <a href="https://admin.getchain.com.cn/login_page?reg_source=0102#/register" target="_blank" -->
        <!-- data-sensors="首页_首页_顶部导航-免费试用7天" class="navRegistered btn-effect" data-count="pc-首页_顶部导航_免费试用7天" -->
        <!-- rel="nofollow">开放平台</a> -->
      </div>
    </div>
  </div>
</template>

<script>
import XRouterLink from './XRouterLink.vue';
export default {
  name: 'bodyHead',
  data() {
    return {
      navHoverClass: ''
    };
  },
  components: {
    'x-router-link': XRouterLink,
  },
  methods: {
    toggleNavClass(className) {
      this.navHoverClass = className;
    }
  }
};
</script>


<style lang="scss" scoped>
.nav {
  position: fixed;
  left: 0;
  width: 100%;
  height: 72px;
  line-height: 72px;
  z-index: 6;
  -webkit-transition: background-color 0.1s;
  transition: background-color 0.1s;

  .nav-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    height: 72px;
    margin: 0 auto;
  }

  .nav-logo_wrap {
    display: block;
    height: 34px;
    width: 129px;
  }

  .nav-func {
    height: 72px;
    font-size: 0;
  }

  .nav-func_item {
    position: relative;
    display: inline-block;
    height: inherit;
    margin: 0 20px;
    font-size: 16px;
    font-weight: 400;

    &:hover {
      .product-list {
        max-height: 500px;
        border-bottom: 1px solid #f5f6f9;
      }

      .more-list {
        max-height: 500px;
      }
    }
  }

  .more-list,
  .product-list {
    max-height: 0;
    background: #fff;
    top: 70px;
  }

  .nav-func_item-new {
    position: relative;
  }

  .nav-func_item-new:before {
    content: 'NEW';
    position: absolute;
    right: 5px;
    top: 10px;
    width: 48px;
    height: 24px;
    line-height: 24px;
    border-radius: 12px;
    background: #ff3535;
    text-align: center;
    font-size: 12px;
    color: #fff;
    transform: scale(0.5);
    transform-origin: right top;
  }

  .nav-item_select:after,
  .nav-item_select:before {
    content: '';
    bottom: 0;
    height: 2px;
    left: 0;
    width: 100%;
  }

  .nav-func_item-new:after {
    content: '';
    position: absolute;
    right: 14px;
    top: 22px;
    border: 3px solid transparent;
    border-top: 3px solid #ff3535;
  }

  .nav-item_select {
    position: relative;
  }

  .nav-item_select:after {
    position: absolute;
    background: #1472ff;
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease-in-out;
  }

  .nav-item_select:before {
    position: absolute;
  }

  .nav-func_item-select {
    color: #1472ff;
  }

  .nav-more {
    cursor: pointer;
    margin-right: 25px;
  }

  .nav-more:hover .arrow-down {
    transform: rotate(180deg);
  }

  .arrow-down {
    position: absolute;
    top: 0;
    right: -16px;
    font-size: 12px;
    margin: 0 0 0 6px;
  }

  .arrow-down:before {
    color: #353535;
  }

  .product-list {
    display: flex;
    justify-content: center;
    position: fixed;
    left: 0;
    width: 100%;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.05);
    font-weight: 400;
    cursor: default;
    z-index: 200;
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
  }

  .product-list .product-item {
    width: 229px;
    margin-top: 32px;
    padding-bottom: 32px;
    padding-left: 30px;
    box-sizing: border-box;
    position: relative;
  }

  .product-list .product-item__title {
    line-height: 17px;
    height: 29px;
    font-size: 14px;
    font-weight: 600;
    color: #666;
    padding: 0 0 0 12px;
  }

  .product-list .margin-top-28 {
    margin-top: 14px;
  }

  .product-list .product-item__func {
    display: block;
    overflow: hidden;
    padding: 0 0 0 12px;
  }

  .product-list .product-item__func:hover .product-item__name {
    transition: all 0.3s;
    color: #1472ff;
  }

  .product-list .product-item__func.product-item__func-sp:hover {
    transition: all 0.3s;
    background: #fff;
  }

  .product-list .product-item__name {
    line-height: 20px;
    font-size: 16px;
    font-weight: 600;
    color: #3d3d3d;
    margin: 12px 0 5px;
  }

  .product-list .product-item__tip {
    line-height: 17px;
    font-size: 12px;
    color: #999;
    margin: 0 0 12px;
  }

  .more-list {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: -30px;
    width: 128px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    border-radius: 0 0 4px 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05),
      0 6px 12px 0 rgba(0, 0, 0, 0.04);
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
    z-index: 200;
  }

  .more-item {
    display: inline-block;
    line-height: 20px;
    margin: 26px 0 0;
  }

  .more-item:hover {
    color: #1472ff;
  }

  .more-item:last-child {
    margin-bottom: 26px;
  }
}

.navCommon {
  .nav-func_btn {
    color: #333;
  }

  .nav-func_submit:hover {
    color: #1472ff;
  }

  .nav-func_forFree {
    background: #1472ff;
    color: #fff;
  }

  .nav-func_forFree:hover {
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    background: #136ffe;
  }

  .nav-func_item:not(.nav-item_select):hover {
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    color: #1472ff;
  }

  .nav-func_item:not(.nav-item_select):hover .arrow-down:before {
    color: #1472ff;
  }

  .navLogin {
    color: #fff;
    font-size: 16px;
  }

  .navRegistered {
    height: 32px;
    line-height: 30px;
    border-radius: 16px;
    background: #fff;
    cursor: pointer;
    display: inline-block;
    color: #1472ff;
    text-align: center;
    font-size: 16px;
    border: 1px solid transparent;
  }

  .login-btn {
    margin-right: 24px;
  }
}

.transparentNav {
  .nav-logo_wrap {
    background: url('~@/assets/images/logo_white.png') center no-repeat;
    background-size: contain;
  }

  .arrow-down:before,
  .nav-func_item {
    color: #fff;
  }

  .nav-item_select {
    opacity: 0.6;
  }
}

.whiteNav {
  background-color: #fff;

  .nav-logo_wrap {
    background: url('~@/assets/images/logo.png') center no-repeat;
    background-size: contain;
  }

  .nav-func_btn,
  .nav-func_item {
    color: #333;
  }

  .nav-func_submit:hover {
    color: #1472ff;
  }

  .arrow-down:before {
    color: #353535;
  }

  .nav-func_forFree {
    background: #1472ff;
    color: #fff;
  }

  .nav-func_forFree:hover {
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    background: #136ffe;
  }

  .nav-item_select {
    color: #1472ff;
    opacity: 1;
  }

  .nav-func_item:hover {
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    color: #1472ff;
  }

  .nav-func_item:hover .arrow-down:before,
  .navLogin {
    color: #1472ff;
  }

  .navRegistered {
    background: #1472ff;
    color: #fff;
    border: 1px solid transparent;
  }
}
</style>
